import * as React from "react";
import { observer } from "mobx-react-lite";
import { ImageCarousel } from "src/components/ImageCarousel";
import { onError } from "src/common/onError";
import { Bom2aPositionsStore } from "../../../Bom2aPositionsStore";
import { Bom2aEdPositionRow } from "../../../Bom2aPositionsTypes";
import styles from "./Bom2aPhotoCell.module.less";

type PropsBom2aPhotoCell = {
  row: Bom2aEdPositionRow;
  store: Bom2aPositionsStore;
};

// TODO: Сейчас это поле не является частью сетки.

export const Bom2aPhotoCell: React.FC<PropsBom2aPhotoCell> = observer(
  (props) => {
    const { row, store } = props;
    const { value, id: valueId } = row.fields.photo;

    const onChange = async (newValue: string | null | undefined) => {
      const v = newValue || "";
      await store.saveFieldValue(row.id, valueId, v);
      store.updateFieldValue(row.id, "photo", v);
    };

    return (
      <div className={styles.photoBox}>
        <ImageCarousel
          multiple={false}
          maxCount={1}
          value={value ? [value] : []}
          onChange={(nv) => {
            onChange(!nv?.length ? null : nv[0]!).catch(onError);
          }}
        />
      </div>
    );
  },
);
